import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Card,
  CardContent,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Alert,
  AlertTitle,
  Avatar,
  Menu,
  Tooltip,
  Fab,
  Badge,
  Switch,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  LinearProgress,
  AccordionSummary,
  AccordionDetails,
  Accordion
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area
} from 'recharts';
import {
  Add as AddIcon,
  Store as StoreIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Inventory as InventoryIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as AttachMoneyIcon,
  Star as StarIcon,
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Schedule as ScheduleIcon,
  ManageAccounts as ManageAccountsIcon,
  CloudUpload as CloudUploadIcon,
  Description as DescriptionIcon,
  AttachFile as AttachFileIcon,
  Delete as DeleteFileIcon,
  AccountBalance as AccountBalanceIcon,
  Payment as PaymentIcon,
  MonetizationOn as MonetizationOnIcon,
  TrendingUp as TrendingUpIcon2,
  ShoppingCart as ShoppingCartIcon2,
  People as PeopleIcon2,
  Assessment as AssessmentIcon,
  CheckCircle as CheckCircleIcon2,
  Warning as WarningIcon,
  Info as InfoIcon,
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';

const StoreManager = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterBazar, setFilterBazar] = useState('all');
  
  // Form state for add dialog
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedUpazilla, setSelectedUpazilla] = useState('');
  const [selectedBazar, setSelectedBazar] = useState('');

  // Document upload state
  const [uploadedDocs, setUploadedDocs] = useState({
    tradeLicense: null,
    nationalId: null,
    passport: null,
    otherDocs: []
  });

  // Store details dialog state
  const [storeDetailsOpen, setStoreDetailsOpen] = useState(false);
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [detailsTab, setDetailsTab] = useState(0);

  // Hierarchical location data
  const locationData = {
    districts: [
      {
        id: 1,
        name: 'ঢাকা',
        nameEn: 'Dhaka',
      },
      {
        id: 2,
        name: 'চট্টগ্রাম',
        nameEn: 'Chittagong',
      }
    ],
    upazillas: [
      {
        id: 1,
        name: 'ধানমন্ডি',
        nameEn: 'Dhanmondi',
        districtId: 1,
      },
      {
        id: 2,
        name: 'গুলশান',
        nameEn: 'Gulshan',
        districtId: 1,
      },
      {
        id: 3,
        name: 'পাহাড়তলী',
        nameEn: 'Pahartali',
        districtId: 2,
      }
    ],
    bazars: [
      {
        id: 1,
        name: 'ধানমন্ডি কেন্দ্রীয় বাজার',
        nameEn: 'Dhanmondi Central Market',
        districtId: 1,
        upazillaId: 1,
      },
      {
        id: 2,
        name: 'নিউ মার্কেট',
        nameEn: 'New Market',
        districtId: 1,
        upazillaId: 1,
      },
      {
        id: 3,
        name: 'গুলশান ২ বাজার',
        nameEn: 'Gulshan 2 Market',
        districtId: 1,
        upazillaId: 2,
      },
      {
        id: 4,
        name: 'চট্টগ্রাম কেন্দ্রীয় বাজার',
        nameEn: 'Chittagong Central Market',
        districtId: 2,
        upazillaId: 3,
      }
    ]
  };

  // Mock data for stores
  const [stores, setStores] = useState([
    {
      id: 1,
      name: 'তাজা সবজি দোকান',
      nameEn: 'Fresh Vegetable Store',
      ownerName: 'করিম উদ্দিন',
      ownerPhone: '01712345678',
      ownerEmail: 'karim@example.com',
      bazarName: 'ধানমন্ডি কেন্দ্রীয় বাজার',
      district: 'ঢাকা',
      upazilla: 'ধানমন্ডি',
      address: 'দোকান নং ২৩, ধানমন্ডি কেন্দ্রীয় বাজার',
      category: 'সবজি',
      status: 'সক্রিয়',
      verified: true,
      totalProducts: 45,
      monthlyRevenue: 125000,
      rating: 4.5,
      totalOrders: 234,
      joinDate: '২০২৩-০৫-১৫',
      operatingHours: '৬:০০ - ২২:০০',
      licenseNumber: 'VEG-2023-001'
    },
    {
      id: 2,
      name: 'মাংস প্যারাডাইজ',
      nameEn: 'Meat Paradise',
      ownerName: 'রহিম আলী',
      ownerPhone: '01812345679',
      ownerEmail: 'rahim@example.com',
      bazarName: 'নিউ মার্কেট',
      district: 'ঢাকা',
      upazilla: 'ধানমন্ডি',
      address: 'দোকান নং ৪৫, নিউ মার্কেট',
      category: 'মাংস',
      status: 'অপেক্ষমান',
      verified: false,
      totalProducts: 28,
      monthlyRevenue: 89000,
      rating: 4.2,
      totalOrders: 156,
      joinDate: '২০২৩-০৬-২০',
      operatingHours: '৮:০০ - ২০:০০',
      licenseNumber: 'MEAT-2023-002'
    },
    {
      id: 3,
      name: 'ফলের রাজ্য',
      nameEn: 'Fruit Kingdom',
      ownerName: 'সালেহা খাতুন',
      ownerPhone: '01912345680',
      ownerEmail: 'saleha@example.com',
      bazarName: 'গুলশান ২ বাজার',
      district: 'ঢাকা',
      upazilla: 'গুলশান',
      address: 'দোকান নং ১২, গুলশান ২ বাজার',
      category: 'ফল',
      status: 'সক্রিয়',
      verified: true,
      totalProducts: 67,
      monthlyRevenue: 156000,
      rating: 4.7,
      totalOrders: 389,
      joinDate: '২০২৩-০৪-১০',
      operatingHours: '৭:০০ - ২১:০০',
      licenseNumber: 'FRUIT-2023-003'
    },
    {
      id: 4,
      name: 'মিষ্টি কর্নার',
      nameEn: 'Sweet Corner',
      ownerName: 'আলিম মিয়া',
      ownerPhone: '01612345681',
      ownerEmail: 'alim@example.com',
      bazarName: 'ধানমন্ডি কেন্দ্রীয় বাজার',
      district: 'ঢাকা',
      upazilla: 'ধানমন্ডি',
      address: 'দোকান নং ৮৭, ধানমন্ডি কেন্দ্রীয় বাজার',
      category: 'মিষ্টি',
      status: 'নিষ্ক্রিয়',
      verified: true,
      totalProducts: 34,
      monthlyRevenue: 67000,
      rating: 4.1,
      totalOrders: 123,
      joinDate: '২০২৩-০৩-২৫',
      operatingHours: '৮:০০ - ২২:০০',
      licenseNumber: 'SWEET-2023-004'
    }
  ]);

  const categories = ['সবজি', 'ফল', 'মাংস', 'মাছ', 'চাল ও ডাল', 'দুগ্ধজাত', 'মিষ্টি', 'মসলা'];

  // Statistics
  const totalStats = {
    totalStores: stores.length,
    activeStores: stores.filter(s => s.status === 'সক্রিয়').length,
    pendingStores: stores.filter(s => s.status === 'অপেক্ষমান').length,
    verifiedStores: stores.filter(s => s.verified).length,
    totalRevenue: stores.reduce((sum, s) => sum + s.monthlyRevenue, 0),
    averageRating: (stores.reduce((sum, s) => sum + s.rating, 0) / stores.length).toFixed(1)
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleAddStore = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // Reset form state
    setSelectedDistrict('');
    setSelectedUpazilla('');
    setSelectedBazar('');
    // Reset document state
    setUploadedDocs({
      tradeLicense: null,
      nationalId: null,
      passport: null,
      otherDocs: []
    });
  };

  const handleDistrictChange = (districtId) => {
    setSelectedDistrict(districtId);
    setSelectedUpazilla(''); // Reset upazilla when district changes
    setSelectedBazar(''); // Reset bazar when district changes
  };

  const handleUpazillaChange = (upazillaId) => {
    setSelectedUpazilla(upazillaId);
    setSelectedBazar(''); // Reset bazar when upazilla changes
  };

  // Get filtered data for cascading dropdowns
  const getAvailableUpazillas = () => {
    return locationData.upazillas.filter(upazilla => upazilla.districtId == selectedDistrict);
  };

  const getAvailableBazars = () => {
    return locationData.bazars.filter(bazar => bazar.upazillaId == selectedUpazilla);
  };

  const handleActionMenuOpen = (event, store) => {
    setActionMenuAnchor(event.currentTarget);
    setSelectedStore(store);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
    setSelectedStore(null);
  };

  const handleStatusChange = (storeId, newStatus) => {
    setStores(stores.map(store => 
      store.id === storeId ? { ...store, status: newStatus } : store
    ));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'সক্রিয়': return 'success';
      case 'অপেক্ষমান': return 'warning';
      case 'নিষ্ক্রিয়': return 'error';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'সক্রিয়': return <CheckCircleIcon />;
      case 'অপেক্ষমান': return <PendingIcon />;
      case 'নিষ্ক্রিয়': return <CancelIcon />;
      default: return <PendingIcon />;
    }
  };

  const filteredStores = stores.filter(store => {
    const matchesSearch = store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         store.ownerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         store.category.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = filterStatus === 'all' || store.status === filterStatus;
    
    // Update bazar filter to work with both names (old data) and IDs (new data)
    const matchesBazar = filterBazar === 'all' || 
                        store.bazarName === filterBazar || 
                        store.bazarId === filterBazar ||
                        (locationData.bazars.find(b => b.id == filterBazar)?.name === store.bazarName);
    
    return matchesSearch && matchesStatus && matchesBazar;
  });

  // Document upload handlers
  const handleFileUpload = (docType, file) => {
    if (docType === 'otherDocs') {
      setUploadedDocs(prev => ({
        ...prev,
        otherDocs: [...prev.otherDocs, file]
      }));
    } else {
      setUploadedDocs(prev => ({
        ...prev,
        [docType]: file
      }));
    }
  };

  const handleFileRemove = (docType, index = null) => {
    if (docType === 'otherDocs' && index !== null) {
      setUploadedDocs(prev => ({
        ...prev,
        otherDocs: prev.otherDocs.filter((_, i) => i !== index)
      }));
    } else {
      setUploadedDocs(prev => ({
        ...prev,
        [docType]: null
      }));
    }
  };

  const getFileDisplayName = (file) => {
    return file?.name || 'ফাইল নির্বাচিত';
  };

  // Store details handlers
  const handleStoreClick = (store) => {
    setSelectedStoreDetails(store);
    setStoreDetailsOpen(true);
    setDetailsTab(0);
  };

  const handleStoreDetailsClose = () => {
    setStoreDetailsOpen(false);
    setSelectedStoreDetails(null);
    setDetailsTab(0);
  };

  const handleDetailsTabChange = (event, newValue) => {
    setDetailsTab(newValue);
  };

  const handleApproveStore = (storeId) => {
    setStores(stores.map(store => 
      store.id === storeId ? { ...store, status: 'সক্রিয়', verified: true } : store
    ));
  };

  const handleRejectStore = (storeId) => {
    setStores(stores.map(store => 
      store.id === storeId ? { ...store, status: 'নিষ্ক্রিয়' } : store
    ));
  };

  // Generate sales performance data for the last 30 days
  const generateSalesData = (store) => {
    const data = [];
    const today = new Date();
    
    for (let i = 29; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      
      // Generate realistic sales data with some variation
      const baseRevenue = store.monthlyRevenue / 30;
      const baseOrders = store.totalOrders / 30;
      
      // Add some randomness to make it look realistic
      const revenueVariation = (Math.random() - 0.5) * 0.4; // ±20% variation
      const orderVariation = (Math.random() - 0.5) * 0.4;
      
      // Weekend effect (lower sales on Friday-Saturday)
      const dayOfWeek = date.getDay();
      const weekendMultiplier = (dayOfWeek === 5 || dayOfWeek === 6) ? 0.7 : 1;
      
      const revenue = Math.round(baseRevenue * (1 + revenueVariation) * weekendMultiplier);
      const orders = Math.round(baseOrders * (1 + orderVariation) * weekendMultiplier);
      
      data.push({
        date: date.getDate() + '/' + (date.getMonth() + 1),
        fullDate: date.toLocaleDateString('bn-BD'),
        revenue: revenue,
        orders: orders,
        customers: Math.round(orders * 0.8), // Assuming some repeat customers
      });
    }
    
    return data;
  };

  // Custom tooltip for the chart
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Paper sx={{ p: 2, bgcolor: 'rgba(255, 255, 255, 0.95)', border: '1px solid #ccc' }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            তারিখ: {payload[0]?.payload?.fullDate}
          </Typography>
          {payload.map((entry, index) => (
            <Typography 
              key={index}
              variant="body2" 
              sx={{ color: entry.color, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <Box 
                sx={{ 
                  width: 12, 
                  height: 12, 
                  bgcolor: entry.color, 
                  borderRadius: '50%' 
                }} 
              />
              {entry.name}: {entry.name === 'আয়' ? '৳' : ''}{entry.value.toLocaleString('bn-BD')}
              {entry.name === 'অর্ডার' || entry.name === 'গ্রাহক' ? 'টি' : ''}
            </Typography>
          ))}
        </Paper>
      );
    }
    return null;
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
            <StoreIcon sx={{ fontSize: 40 }} />
            দোকান ম্যানেজার
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            গ্রামীণবাজারের সকল দোকান পরিচালনা - অনুমোদন, যাচাইকরণ এবং নিরীক্ষণ
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddStore}
          sx={{
            background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
            color: 'white',
            px: 3,
            py: 1.5,
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            }
          }}
        >
          নতুন দোকান যোগ করুন
        </Button>
      </Box>

      {/* Info Alert */}
      <Alert severity="info" sx={{ mb: 3 }} icon={<ManageAccountsIcon />}>
        <AlertTitle>দোকান ম্যানেজার সম্পর্কে</AlertTitle>
        এই সিস্টেমের মাধ্যমে সকল দোকানের আবেদন, অনুমোদন, যাচাইকরণ এবং পরিচালনা করুন। দোকানের পারফরমেন্স মনিটর করুন এবং প্রয়োজনীয় পদক্ষেপ নিন।
      </Alert>

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <StoreIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.totalStores}</Typography>
                  <Typography variant="body2">মোট দোকান</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <CheckCircleIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.activeStores}</Typography>
                  <Typography variant="body2">সক্রিয় দোকান</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <PendingIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.pendingStores}</Typography>
                  <Typography variant="body2">অপেক্ষমান</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <CheckCircleIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.verifiedStores}</Typography>
                  <Typography variant="body2">যাচাইকৃত</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', color: '#333' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.7)' }}>
                  <AttachMoneyIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>৳{(totalStats.totalRevenue/1000).toFixed(0)}K</Typography>
                  <Typography variant="body2">মাসিক আয়</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', color: '#333' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.7)' }}>
                  <StarIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.averageRating}</Typography>
                  <Typography variant="body2">গড় রেটিং</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search and Filter Bar */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              placeholder="দোকান, মালিক বা ক্যাটাগরি অনুসন্ধান করুন..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>অবস্থা ফিল্টার</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="অবস্থা ফিল্টার"
              >
                <MenuItem value="all">সব অবস্থা</MenuItem>
                <MenuItem value="সক্রিয়">সক্রিয়</MenuItem>
                <MenuItem value="অপেক্ষমান">অপেক্ষমান</MenuItem>
                <MenuItem value="নিষ্ক্রিয়">নিষ্ক্রিয়</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>বাজার ফিল্টার</InputLabel>
              <Select
                value={filterBazar}
                onChange={(e) => setFilterBazar(e.target.value)}
                label="বাজার ফিল্টার"
              >
                <MenuItem value="all">সব বাজার</MenuItem>
                {locationData.bazars.map((bazar) => (
                  <MenuItem key={bazar.id} value={bazar.id}>{bazar.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button 
              variant="outlined" 
              fullWidth
              onClick={() => {
                setSearchTerm('');
                setFilterStatus('all');
                setFilterBazar('all');
              }}
            >
              রিসেট
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Stores Table */}
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>দোকানের তথ্য</TableCell>
                <TableCell>মালিক</TableCell>
                <TableCell>অবস্থান</TableCell>
                <TableCell>ক্যাটাগরি</TableCell>
                <TableCell align="center">পণ্য</TableCell>
                <TableCell align="center">রেটিং</TableCell>
                <TableCell align="center">মাসিক আয়</TableCell>
                <TableCell align="center">অবস্থা</TableCell>
                <TableCell align="center">যাচাই</TableCell>
                <TableCell align="center">অ্যাকশন</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStores.map((store) => (
                <TableRow key={store.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar 
                        variant="rounded" 
                        sx={{ width: 48, height: 48, bgcolor: 'primary.light' }}
                      >
                        <StoreIcon />
                      </Avatar>
                      <Box>
                        <Typography 
                          variant="subtitle2" 
                          sx={{ 
                            fontWeight: 600,
                            cursor: 'pointer',
                            color: 'primary.main',
                            '&:hover': {
                              textDecoration: 'underline'
                            }
                          }}
                          onClick={() => handleStoreClick(store)}
                        >
                          {store.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          ID: {store.id} | যোগদান: {store.joinDate}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {store.ownerName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {store.ownerPhone}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {store.bazarName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {store.district} → {store.upazilla}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={store.category} 
                      variant="outlined"
                      size="small"
                      sx={{ borderRadius: 1 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {store.totalProducts}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                      <StarIcon sx={{ fontSize: 16, color: '#ff9800' }} />
                      <Typography variant="body2">{store.rating}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      ৳{(store.monthlyRevenue/1000).toFixed(0)}K
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={store.status}
                      color={getStatusColor(store.status)}
                      size="small"
                      icon={getStatusIcon(store.status)}
                      sx={{ borderRadius: 1 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {store.verified ? (
                      <Chip label="যাচাইকৃত" color="success" size="small" variant="outlined" />
                    ) : (
                      <Chip label="অযাচাইকৃত" color="warning" size="small" variant="outlined" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={(e) => handleActionMenuOpen(e, store)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Action Menu */}
      <Menu
        anchorEl={actionMenuAnchor}
        open={Boolean(actionMenuAnchor)}
        onClose={handleActionMenuClose}
      >
        <MenuItem onClick={handleActionMenuClose}>
          <VisibilityIcon sx={{ mr: 1, fontSize: 18 }} />
          বিস্তারিত দেখুন
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose}>
          <EditIcon sx={{ mr: 1, fontSize: 18 }} />
          সম্পাদনা করুন
        </MenuItem>
        <MenuItem onClick={() => {
          if (selectedStore) {
            handleStatusChange(selectedStore.id, selectedStore.status === 'সক্রিয়' ? 'নিষ্ক্রিয়' : 'সক্রিয়');
          }
          handleActionMenuClose();
        }}>
          {selectedStore?.status === 'সক্রিয়' ? <CancelIcon /> : <CheckCircleIcon />}
          <Typography sx={{ ml: 1, fontSize: 14 }}>
            {selectedStore?.status === 'সক্রিয়' ? 'নিষ্ক্রিয় করুন' : 'সক্রিয় করুন'}
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose} sx={{ color: 'error.main' }}>
          <DeleteIcon sx={{ mr: 1, fontSize: 18 }} />
          মুছে ফেলুন
        </MenuItem>
      </Menu>

      {/* Add Store Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{ 
          background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)', 
          color: 'white' 
        }}>
          নতুন দোকান যোগ করুন
        </DialogTitle>
        <DialogContent 
          sx={{ 
            mt: 2,
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
            overflow: 'auto'
          }}
        >
          <Grid container spacing={3}>
            {/* Location Selection - District, Upazilla, Bazar */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                অবস্থান নির্বাচন
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth required>
                <InputLabel>জেলা নির্বাচন করুন</InputLabel>
                <Select
                  value={selectedDistrict}
                  onChange={(e) => handleDistrictChange(e.target.value)}
                  label="জেলা নির্বাচন করুন"
                >
                  {locationData.districts.map((district) => (
                    <MenuItem key={district.id} value={district.id}>
                      {district.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth required disabled={!selectedDistrict}>
                <InputLabel>উপজেলা নির্বাচন করুন</InputLabel>
                <Select
                  value={selectedUpazilla}
                  onChange={(e) => handleUpazillaChange(e.target.value)}
                  label="উপজেলা নির্বাচন করুন"
                >
                  {getAvailableUpazillas().map((upazilla) => (
                    <MenuItem key={upazilla.id} value={upazilla.id}>
                      {upazilla.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth required disabled={!selectedUpazilla}>
                <InputLabel>বাজার নির্বাচন করুন</InputLabel>
                <Select
                  value={selectedBazar}
                  onChange={(e) => setSelectedBazar(e.target.value)}
                  label="বাজার নির্বাচন করুন"
                >
                  {getAvailableBazars().map((bazar) => (
                    <MenuItem key={bazar.id} value={bazar.id}>
                      {bazar.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Store Information */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                দোকানের তথ্য
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="দোকানের নাম (বাংলা)"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="দোকানের নাম (ইংরেজি)"
                variant="outlined"
                required
              />
            </Grid>

            {/* Owner Information */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                মালিকের তথ্য
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="মালিকের নাম"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="মোবাইল নম্বর"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="ইমেইল"
                variant="outlined"
                type="email"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>ক্যাটাগরি</InputLabel>
                <Select label="ক্যাটাগরি">
                  {categories.map((category) => (
                    <MenuItem key={category} value={category}>{category}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Business Information */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, mt: 2, color: 'primary.main', fontWeight: 600 }}>
                ব্যবসায়িক তথ্য
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="লাইসেন্স নম্বর"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="পরিচালনার সময়"
                variant="outlined"
                placeholder="৬:০০ - ২২:০০"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="দোকানের ঠিকানা"
                variant="outlined"
                multiline
                rows={2}
                required
                placeholder="দোকান নং, রোড নং, বিস্তারিত ঠিকানা..."
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>প্রাথমিক অবস্থা</InputLabel>
                <Select label="প্রাথমিক অবস্থা" defaultValue="অপেক্ষমান">
                  <MenuItem value="সক্রিয়">সক্রিয়</MenuItem>
                  <MenuItem value="অপেক্ষমান">অপেক্ষমান</MenuItem>
                  <MenuItem value="নিষ্ক্রিয়">নিষ্ক্রিয়</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Document Upload Section */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, mt: 3, color: 'primary.main', fontWeight: 600 }}>
                প্রয়োজনীয় কাগজপত্র
              </Typography>
            </Grid>

            {/* Trade License */}
            <Grid item xs={12} sm={6}>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  textAlign: 'center', 
                  border: uploadedDocs.tradeLicense ? '2px solid #4caf50' : '2px dashed #ccc',
                  bgcolor: uploadedDocs.tradeLicense ? '#f3f9f3' : '#fafafa',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                  id="trade-license-upload"
                  onChange={(e) => e.target.files[0] && handleFileUpload('tradeLicense', e.target.files[0])}
                />
                <label htmlFor="trade-license-upload" style={{ cursor: 'pointer', width: '100%', display: 'block' }}>
                  {uploadedDocs.tradeLicense ? (
                    <Box>
                      <DescriptionIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
                      <Typography variant="body2" color="success.main" sx={{ fontWeight: 600 }}>
                        ট্রেড লাইসেন্স আপলোড সম্পন্ন
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {getFileDisplayName(uploadedDocs.tradeLicense)}
                      </Typography>
                      <Box sx={{ mt: 1 }}>
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFileRemove('tradeLicense');
                          }}
                        >
                          <DeleteFileIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box>
                      <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                        ট্রেড লাইসেন্স আপলোড করুন *
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        PDF, JPG, PNG (সর্বোচ্চ ৫ MB)
                      </Typography>
                    </Box>
                  )}
                </label>
              </Paper>
            </Grid>

            {/* National ID */}
            <Grid item xs={12} sm={6}>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  textAlign: 'center', 
                  border: uploadedDocs.nationalId ? '2px solid #4caf50' : '2px dashed #ccc',
                  bgcolor: uploadedDocs.nationalId ? '#f3f9f3' : '#fafafa',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                  id="national-id-upload"
                  onChange={(e) => e.target.files[0] && handleFileUpload('nationalId', e.target.files[0])}
                />
                <label htmlFor="national-id-upload" style={{ cursor: 'pointer', width: '100%', display: 'block' }}>
                  {uploadedDocs.nationalId ? (
                    <Box>
                      <DescriptionIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
                      <Typography variant="body2" color="success.main" sx={{ fontWeight: 600 }}>
                        জাতীয় পরিচয়পত্র আপলোড সম্পন্ন
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {getFileDisplayName(uploadedDocs.nationalId)}
                      </Typography>
                      <Box sx={{ mt: 1 }}>
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFileRemove('nationalId');
                          }}
                        >
                          <DeleteFileIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box>
                      <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                        জাতীয় পরিচয়পত্র আপলোড করুন *
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        PDF, JPG, PNG (সর্বোচ্চ ৫ MB)
                      </Typography>
                    </Box>
                  )}
                </label>
              </Paper>
            </Grid>

            {/* Passport (Optional) */}
            <Grid item xs={12} sm={6}>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  textAlign: 'center', 
                  border: uploadedDocs.passport ? '2px solid #4caf50' : '2px dashed #ccc',
                  bgcolor: uploadedDocs.passport ? '#f3f9f3' : '#fafafa',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                  id="passport-upload"
                  onChange={(e) => e.target.files[0] && handleFileUpload('passport', e.target.files[0])}
                />
                <label htmlFor="passport-upload" style={{ cursor: 'pointer', width: '100%', display: 'block' }}>
                  {uploadedDocs.passport ? (
                    <Box>
                      <DescriptionIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
                      <Typography variant="body2" color="success.main" sx={{ fontWeight: 600 }}>
                        পাসপোর্ট আপলোড সম্পন্ন
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {getFileDisplayName(uploadedDocs.passport)}
                      </Typography>
                      <Box sx={{ mt: 1 }}>
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFileRemove('passport');
                          }}
                        >
                          <DeleteFileIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box>
                      <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                        পাসপোর্ট আপলোড করুন (ঐচ্ছিক)
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        PDF, JPG, PNG (সর্বোচ্চ ৫ MB)
                      </Typography>
                    </Box>
                  )}
                </label>
              </Paper>
            </Grid>

            {/* Other Documents */}
            <Grid item xs={12} sm={6}>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  textAlign: 'center', 
                  border: '2px dashed #ccc',
                  bgcolor: '#fafafa',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                  id="other-docs-upload"
                  multiple
                  onChange={(e) => {
                    Array.from(e.target.files).forEach(file => {
                      handleFileUpload('otherDocs', file);
                    });
                  }}
                />
                <label htmlFor="other-docs-upload" style={{ cursor: 'pointer', width: '100%', display: 'block' }}>
                  <Box>
                    <AttachFileIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                    <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                      অন্যান্য কাগজপত্র (ঐচ্ছিক)
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      একাধিক ফাইল নির্বাচন করা যাবে
                    </Typography>
                  </Box>
                </label>
              </Paper>
              
              {/* Display uploaded other documents */}
              {uploadedDocs.otherDocs.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                    আপলোড করা ফাইলসমূহ:
                  </Typography>
                  {uploadedDocs.otherDocs.map((file, index) => (
                    <Chip
                      key={index}
                      label={file.name}
                      variant="outlined"
                      size="small"
                      onDelete={() => handleFileRemove('otherDocs', index)}
                      deleteIcon={<DeleteFileIcon />}
                      sx={{ mr: 1, mb: 1 }}
                    />
                  ))}
                </Box>
              )}
            </Grid>

            {/* Document Upload Instructions */}
            <Grid item xs={12}>
              <Alert severity="info" sx={{ mt: 2 }}>
                <AlertTitle>কাগজপত্র সম্পর্কে নির্দেশনা</AlertTitle>
                <Typography variant="body2">
                  • ট্রেড লাইসেন্স এবং জাতীয় পরিচয়পত্র আবশ্যক
                  <br />
                  • সকল ফাইল PDF, JPG বা PNG ফরম্যাটে হতে হবে
                  <br />
                  • প্রতিটি ফাইলের সর্বোচ্চ সাইজ ৫ MB
                  <br />
                  • কাগজপত্র স্পষ্ট ও পড়ার যোগ্য হতে হবে
                </Typography>
              </Alert>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleCloseDialog} variant="outlined">
            বাতিল করুন
          </Button>
          <Button 
            onClick={handleCloseDialog} 
            variant="contained"
            disabled={!selectedBazar || !uploadedDocs.tradeLicense || !uploadedDocs.nationalId}
            sx={{
              background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
              color: 'white',
              '&:hover': {
                background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
              }
            }}
          >
            দোকান যোগ করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="add store"
        onClick={handleAddStore}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
          }
        }}
      >
        <AddIcon />
      </Fab>

      {/* Store Details Dialog */}
      <Dialog 
        open={storeDetailsOpen} 
        onClose={handleStoreDetailsClose} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: { minHeight: '80vh' }
        }}
      >
        {selectedStoreDetails && (
          <>
            <DialogTitle sx={{ 
              bgcolor: selectedStoreDetails.status === 'সক্রিয়' ? 'success.main' : 
                       selectedStoreDetails.status === 'অপেক্ষমান' ? 'warning.main' : 'error.main',
              color: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <StoreIcon />
                <Box>
                  <Typography variant="h6">{selectedStoreDetails.name}</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    মালিক: {selectedStoreDetails.ownerName} | ID: {selectedStoreDetails.id}
                  </Typography>
                </Box>
              </Box>
              <Chip 
                label={selectedStoreDetails.status}
                sx={{ 
                  bgcolor: 'rgba(255,255,255,0.3)', 
                  color: 'white',
                  fontWeight: 600
                }}
              />
            </DialogTitle>

            {/* Tab Navigation */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={detailsTab} onChange={handleDetailsTabChange}>
                <Tab label="সাধারণ তথ্য" />
                {selectedStoreDetails.status === 'সক্রিয়' && <Tab label="পরিসংখ্যান" />}
                {selectedStoreDetails.status === 'অপেক্ষমান' && <Tab label="আবেদনের বিবরণ" />}
                <Tab label="পেমেন্ট ও অর্থ" />
                <Tab label="কার্যক্রম" />
              </Tabs>
            </Box>

            <DialogContent sx={{ p: 0 }}>
              {/* General Information Tab */}
              {detailsTab === 0 && (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={3}>
                    {/* Store Info Card */}
                    <Grid item xs={12} md={6}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <StoreIcon color="primary" />
                            দোকানের তথ্য
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <List dense>
                            <ListItem>
                              <ListItemText 
                                primary="দোকানের নাম" 
                                secondary={selectedStoreDetails.name}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="ইংরেজি নাম" 
                                secondary={selectedStoreDetails.nameEn}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="ক্যাটাগরি" 
                                secondary={selectedStoreDetails.category}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="লাইসেন্স নম্বর" 
                                secondary={selectedStoreDetails.licenseNumber}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="পরিচালনার সময়" 
                                secondary={selectedStoreDetails.operatingHours}
                              />
                            </ListItem>
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Owner Info Card */}
                    <Grid item xs={12} md={6}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PersonIcon color="primary" />
                            মালিকের তথ্য
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <List dense>
                            <ListItem>
                              <ListItemText 
                                primary="নাম" 
                                secondary={selectedStoreDetails.ownerName}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="মোবাইল" 
                                secondary={selectedStoreDetails.ownerPhone}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="ইমেইল" 
                                secondary={selectedStoreDetails.ownerEmail}
                              />
                            </ListItem>
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Location Info Card */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocationOnIcon color="primary" />
                            অবস্থানের তথ্য
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <List dense>
                            <ListItem>
                              <ListItemText 
                                primary="বাজার" 
                                secondary={selectedStoreDetails.bazarName}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="এলাকা" 
                                secondary={`${selectedStoreDetails.district} → ${selectedStoreDetails.upazilla}`}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary="সম্পূর্ণ ঠিকানা" 
                                secondary={selectedStoreDetails.address}
                              />
                            </ListItem>
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Statistics Tab (Active Stores Only) */}
              {detailsTab === 1 && selectedStoreDetails.status === 'সক্রিয়' && (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={3}>
                    {/* Statistics Cards */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <InventoryIcon sx={{ fontSize: 48, mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            {selectedStoreDetails.totalProducts}
                          </Typography>
                          <Typography variant="body2">মোট পণ্য</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <ShoppingCartIcon2 sx={{ fontSize: 48, mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            {selectedStoreDetails.totalOrders}
                          </Typography>
                          <Typography variant="body2">মোট অর্ডার</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', color: 'white' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <MonetizationOnIcon sx={{ fontSize: 48, mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            ৳{(selectedStoreDetails.monthlyRevenue/1000).toFixed(0)}K
                          </Typography>
                          <Typography variant="body2">মাসিক আয়</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <StarIcon sx={{ fontSize: 48, mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            {selectedStoreDetails.rating}
                          </Typography>
                          <Typography variant="body2">গড় রেটিং</Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Performance Chart Placeholder */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <TrendingUpIcon2 color="primary" />
                            বিক্রয় কর্মক্ষমতা (গত ৩০ দিন)
                          </Typography>
                          <Divider sx={{ mb: 3 }} />
                          
                          {/* Chart Controls */}
                          <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <Chip 
                              label="আয়" 
                              variant="outlined" 
                              sx={{ 
                                borderColor: '#8884d8', 
                                color: '#8884d8',
                                '&:hover': { bgcolor: 'rgba(136, 132, 216, 0.1)' }
                              }} 
                            />
                            <Chip 
                              label="অর্ডার" 
                              variant="outlined" 
                              sx={{ 
                                borderColor: '#82ca9d', 
                                color: '#82ca9d',
                                '&:hover': { bgcolor: 'rgba(130, 202, 157, 0.1)' }
                              }} 
                            />
                            <Chip 
                              label="গ্রাহক" 
                              variant="outlined" 
                              sx={{ 
                                borderColor: '#ffc658', 
                                color: '#ffc658',
                                '&:hover': { bgcolor: 'rgba(255, 198, 88, 0.1)' }
                              }} 
                            />
                          </Box>

                          {/* Actual Chart */}
                          <Box sx={{ width: '100%', height: 400 }}>
                            <ResponsiveContainer width="100%" height="100%">
                              <AreaChart
                                data={generateSalesData(selectedStoreDetails)}
                                margin={{
                                  top: 20,
                                  right: 30,
                                  left: 20,
                                  bottom: 20,
                                }}
                              >
                                <defs>
                                  <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#8884d8" stopOpacity={0.3}/>
                                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0.1}/>
                                  </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis 
                                  dataKey="date" 
                                  tick={{ fontSize: 12 }}
                                  stroke="#666"
                                />
                                <YAxis 
                                  yAxisId="revenue"
                                  orientation="left"
                                  tick={{ fontSize: 12 }}
                                  stroke="#8884d8"
                                  domain={['dataMin - 500', 'dataMax + 500']}
                                />
                                <YAxis 
                                  yAxisId="count"
                                  orientation="right"
                                  tick={{ fontSize: 12 }}
                                  stroke="#82ca9d"
                                  domain={['dataMin - 2', 'dataMax + 2']}
                                />
                                <RechartsTooltip content={<CustomTooltip />} />
                                <Legend 
                                  wrapperStyle={{ 
                                    paddingTop: '20px',
                                    fontSize: '14px'
                                  }}
                                />
                                
                                {/* Revenue Area */}
                                <Area
                                  yAxisId="revenue"
                                  type="monotone"
                                  dataKey="revenue"
                                  stroke="#8884d8"
                                  fillOpacity={1}
                                  fill="url(#colorRevenue)"
                                  name="আয়"
                                  strokeWidth={3}
                                />
                                
                                {/* Orders Line */}
                                <Area
                                  yAxisId="count"
                                  type="monotone"
                                  dataKey="orders"
                                  stroke="#82ca9d"
                                  strokeWidth={3}
                                  fill="transparent"
                                  dot={{ fill: '#82ca9d', strokeWidth: 2, r: 4 }}
                                  activeDot={{ r: 6, stroke: '#82ca9d', strokeWidth: 2 }}
                                  name="অর্ডার"
                                />
                                
                                {/* Customers Line */}
                                <Area
                                  yAxisId="count"
                                  type="monotone"
                                  dataKey="customers"
                                  stroke="#ffc658"
                                  strokeWidth={2}
                                  strokeDasharray="5 5"
                                  fill="transparent"
                                  dot={{ fill: '#ffc658', strokeWidth: 2, r: 3 }}
                                  activeDot={{ r: 5, stroke: '#ffc658', strokeWidth: 2 }}
                                  name="গ্রাহক"
                                />
                              </AreaChart>
                            </ResponsiveContainer>
                          </Box>

                          {/* Chart Summary */}
                          <Box sx={{ mt: 3, p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={4}>
                                <Box sx={{ textAlign: 'center' }}>
                                  <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                                    ৳{(selectedStoreDetails.monthlyRevenue).toLocaleString('bn-BD')}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    মোট আয় (৩০ দিন)
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Box sx={{ textAlign: 'center' }}>
                                  <Typography variant="h6" color="success.main" sx={{ fontWeight: 600 }}>
                                    {selectedStoreDetails.totalOrders}টি
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    মোট অর্ডার (৩০ দিন)
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Box sx={{ textAlign: 'center' }}>
                                  <Typography variant="h6" color="warning.main" sx={{ fontWeight: 600 }}>
                                    ৳{Math.round(selectedStoreDetails.monthlyRevenue / selectedStoreDetails.totalOrders).toLocaleString('bn-BD')}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    গড় অর্ডার মূল্য
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Application Details Tab (Pending Stores Only) */}
              {((detailsTab === 1 && selectedStoreDetails.status === 'অপেক্ষমান') || 
                (detailsTab === 2 && selectedStoreDetails.status === 'সক্রিয়')) && (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={3}>
                    {/* Application Status */}
                    <Grid item xs={12}>
                      <Alert 
                        severity={selectedStoreDetails.status === 'অপেক্ষমান' ? 'warning' : 'info'}
                        action={
                          selectedStoreDetails.status === 'অপেক্ষমান' && (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <Button 
                                color="success" 
                                size="small" 
                                variant="contained"
                                onClick={() => handleApproveStore(selectedStoreDetails.id)}
                              >
                                অনুমোদন করুন
                              </Button>
                              <Button 
                                color="error" 
                                size="small" 
                                variant="outlined"
                                onClick={() => handleRejectStore(selectedStoreDetails.id)}
                              >
                                প্রত্যাখ্যান
                              </Button>
                            </Box>
                          )
                        }
                      >
                        <AlertTitle>
                          {selectedStoreDetails.status === 'অপেক্ষমান' ? 'আবেদন পর্যালোচনাধীন' : 'আবেদনের ইতিহাস'}
                        </AlertTitle>
                        {selectedStoreDetails.status === 'অপেক্ষমান' ? 
                          'এই দোকানটি অনুমোদনের জন্য অপেক্ষমান। সকল কাগজপত্র যাচাই করে অনুমোদন করুন।' :
                          'এই দোকানটি ইতিমধ্যে অনুমোদিত এবং সক্রিয়।'
                        }
                      </Alert>
                    </Grid>

                    {/* Document Review */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            জমাকৃত কাগজপত্র
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <List>
                            <ListItem>
                              <ListItemIcon>
                                <CheckCircleIcon2 color="success" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="ট্রেড লাইসেন্স"
                                secondary="আপলোড সম্পন্ন - যাচাই প্রয়োজন"
                              />
                              <Button size="small" variant="outlined">দেখুন</Button>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <CheckCircleIcon2 color="success" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="জাতীয় পরিচয়পত্র"
                                secondary="আপলোড সম্পন্ন - যাচাই প্রয়োজন"
                              />
                              <Button size="small" variant="outlined">দেখুন</Button>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <WarningIcon color="warning" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="ব্যাংক তথ্য"
                                secondary="অতিরিক্ত তথ্য প্রয়োজন"
                              />
                              <Button size="small" variant="contained" color="warning">অনুরোধ করুন</Button>
                            </ListItem>
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Payment & Finance Tab */}
              {((detailsTab === 2 && selectedStoreDetails.status === 'অপেক্ষমান') || 
                (detailsTab === 2 && selectedStoreDetails.status === 'সক্রিয়') ||
                (detailsTab === 3 && selectedStoreDetails.status === 'সক্রিয়')) && (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={3}>
                    {/* Payment Overview */}
                    <Grid item xs={12} md={4}>
                      <Card>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <AccountBalanceIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                            ৳{(selectedStoreDetails.monthlyRevenue * 0.85 / 1000).toFixed(1)}K
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            বর্তমান ব্যালেন্স
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <Card>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <PaymentIcon sx={{ fontSize: 48, color: 'info.main', mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'info.main' }}>
                            ৳{(selectedStoreDetails.monthlyRevenue * 0.15 / 1000).toFixed(1)}K
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            মাসিক কমিশন
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <Card>
                        <CardContent sx={{ textAlign: 'center' }}>
                          <TrendingUpIcon2 sx={{ fontSize: 48, color: 'warning.main', mb: 1 }} />
                          <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'warning.main' }}>
                            ৳2.5K
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            পেন্ডিং পেআউট
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Payment Actions */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            পেমেন্ট অ্যাকশন
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <Button variant="contained" color="success" startIcon={<MonetizationOnIcon />}>
                              পেআউট প্রক্রিয়া করুন
                            </Button>
                            <Button variant="outlined" color="primary" startIcon={<AccountBalanceIcon />}>
                              ব্যালেন্স যোগ করুন
                            </Button>
                            <Button variant="outlined" color="info" startIcon={<AssessmentIcon />}>
                              পেমেন্ট রিপোর্ট
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Recent Transactions */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            সাম্প্রতিক লেনদেন
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>তারিখ</TableCell>
                                  <TableCell>বিবরণ</TableCell>
                                  <TableCell align="right">পরিমাণ</TableCell>
                                  <TableCell>অবস্থা</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>২৫ মার্চ, ২০২৫</TableCell>
                                  <TableCell>বিক্রয় কমিশন</TableCell>
                                  <TableCell align="right">৳৮৫০</TableCell>
                                  <TableCell><Chip label="সম্পন্ন" color="success" size="small" /></TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>২৪ মার্চ, ২০২৫</TableCell>
                                  <TableCell>পেআউট</TableCell>
                                  <TableCell align="right">-৳২,৫০০</TableCell>
                                  <TableCell><Chip label="প্রক্রিয়াধীন" color="warning" size="small" /></TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Activity Tab */}
              {((detailsTab === 3 && selectedStoreDetails.status === 'অপেক্ষমান') || 
                (detailsTab === 4 && selectedStoreDetails.status === 'সক্রিয়')) && (
                <Box sx={{ p: 3 }}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        কার্যক্রম লগ
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <InfoIcon color="info" />
                          </ListItemIcon>
                          <ListItemText 
                            primary="দোকান নিবন্ধন সম্পন্ন"
                            secondary={`${selectedStoreDetails.joinDate} তারিখে`}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <CheckCircleIcon2 color="success" />
                          </ListItemIcon>
                          <ListItemText 
                            primary="প্রাথমিক যাচাইকরণ সম্পন্ন"
                            secondary="সকল কাগজপত্র জমা দেওয়া হয়েছে"
                          />
                        </ListItem>
                        {selectedStoreDetails.status === 'সক্রিয়' && (
                          <ListItem>
                            <ListItemIcon>
                              <CheckCircleIcon2 color="success" />
                            </ListItemIcon>
                            <ListItemText 
                              primary="দোকান অনুমোদিত ও সক্রিয়"
                              secondary="বিক্রয় শুরু করতে পারবেন"
                            />
                          </ListItem>
                        )}
                      </List>
                    </CardContent>
                  </Card>
                </Box>
              )}
            </DialogContent>

            <DialogActions sx={{ p: 3, bgcolor: '#f5f5f5' }}>
              <Button onClick={handleStoreDetailsClose} variant="outlined">
                বন্ধ করুন
              </Button>
              {selectedStoreDetails.status === 'অপেক্ষমান' && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button 
                    variant="contained" 
                    color="success"
                    onClick={() => {
                      handleApproveStore(selectedStoreDetails.id);
                      handleStoreDetailsClose();
                    }}
                  >
                    অনুমোদন করুন
                  </Button>
                  <Button 
                    variant="contained" 
                    color="error"
                    onClick={() => {
                      handleRejectStore(selectedStoreDetails.id);
                      handleStoreDetailsClose();
                    }}
                  >
                    প্রত্যাখ্যান করুন
                  </Button>
                </Box>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default StoreManager; 